export const HEIGHT_OFFSET = 235;

export enum SimulationView {
  BASIC = 'Main view',
  RM_REPORT = 'RM% View',
  RRP_REPORT = 'RRP View',
  HARMONIZATION = 'Harmonization',
  KEYFIGURES = 'Key Figures',
}
